<div class="register-container">
    <h2>Register</h2>

    <form (ngSubmit)="onRegister()" [formGroup]="registerForm" class="register-form">

        <!-- Name -->
        <div class="form-group">
            <label for="name">Full Name</label>
            <input id="name" type="text" formControlName="name"/>

            <small class="error"
                   *ngIf="registerForm.get('name')?.touched && registerForm.get('name')?.errors?.['required']">
                Name is required
            </small>

            <small class="error"
                   *ngIf="registerForm.get('name')?.touched && registerForm.get('name')?.errors?.['minlength']">
                Name must be at least 3 characters
            </small>
        </div>

        <!-- Email -->
        <div class="form-group">
            <label for="email">Email</label>

            <input id="email" type="email" formControlName="email"/>

            <small class="error"
                   *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.errors?.['required']">
                Email is required
            </small>

            <small class="error"
                   *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.errors?.['email']">
                Please enter a valid email address
            </small>
        </div>

        <!-- Mobile -->
        <div class="form-group">
            <label for="mobile">Mobile No</label>

            <input
                    id="mobile"
                    type="text"
                    formControlName="mobile"
                    placeholder="Enter 10-digit mobile number"
            />

            <small class="error"
                   *ngIf="registerForm.get('mobile')?.touched && registerForm.get('mobile')?.errors?.['required']">
                Mobile number is required
            </small>

            <small class="error"
                   *ngIf="registerForm.get('mobile')?.touched && registerForm.get('mobile')?.errors?.['pattern']">
                Please enter a valid 10-digit mobile number
            </small>
        </div>

        <!-- Password -->
        <div class="form-group password-group">
            <label for="password">Password</label>
            <div class="password-wrapper">
                <input id="password"
                       [type]="showPassword ? 'text' : 'password'"
                       formControlName="password"/>
                <button
                        type="button"
                        class="toggle-password"
                        (click)="togglePassword()"
                        aria-label="Toggle password visibility"
                >
                    <!-- Eye Open -->
                    <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="eye-icon">
                        <path d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"/>
                    </svg>

                    <!-- Eye Closed -->
                    <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="eye-icon">
                        <path d="M2 2l20 20M10.6 10.6a2 2 0 0 0 2.8 2.8M9.9 5.1A10.9 10.9 0 0 1 12 5c7 0 10 7 10 7a17.6 17.6 0 0 1-4 5.2M6.1 6.1A17.5 17.5 0 0 0 2 12s3 7 10 7c1.4 0 2.7-.3 4-.8"/>
                    </svg>
                </button>
            </div>
            <small class="error"
                   *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.errors?.['required']">
                Password is required
            </small>

            <small class="error"
                   *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.errors?.['minlength']">
                Password must be at least 6 characters
            </small>

        </div>

        <!-- Confirm Password -->
        <div class="form-group password-group">
            <label for="confirmPassword">Confirm Password</label>
            <div class="password-wrapper">
                <input id="confirmPassword"
                       [type]="showConfirmPassword ? 'text' : 'password'"
                       formControlName="confirmPassword"/>
                <button
                        type="button"
                        class="toggle-password"
                        (click)="toggleConfirmPassword()"
                        aria-label="Toggle password visibility"
                >
                    <!-- Eye Open -->
                    <svg *ngIf="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                         class="eye-icon">
                        <path d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"/>
                    </svg>

                    <!-- Eye Closed -->
                    <svg *ngIf="!showConfirmPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                         class="eye-icon">
                        <path d="M2 2l20 20M10.6 10.6a2 2 0 0 0 2.8 2.8M9.9 5.1A10.9 10.9 0 0 1 12 5c7 0 10 7 10 7a17.6 17.6 0 0 1-4 5.2M6.1 6.1A17.5 17.5 0 0 0 2 12s3 7 10 7c1.4 0 2.7-.3 4-.8"/>
                    </svg>
                </button>
            </div>
            <small class="error"
                   *ngIf="registerForm.get('confirmPassword')?.touched && registerForm.get('confirmPassword')?.errors?.['required']">
                Confirm password is required
            </small>

            <small class="error"
                   *ngIf="registerForm.errors?.['passwordMismatch'] && registerForm.get('confirmPassword')?.touched">
                Passwords do not match
            </small>
        </div>

        <div class="button-group">
            <button type="submit"
                    class="LoginBtn"
                    *ngIf="!isPlacingOrder"
                    [disabled]="registerForm.invalid">Register</button>

            <span *ngIf="isPlacingOrder" class="loader"></span>
        </div>

    </form>
</div>